import { AuthFooterLanguage, AuthWrapper } from '../AuthComponents';
import {
  CreateNewPasswordHeader,
  CreateNewPasswordForm,
  CreateNewPasswordFooter,
} from './CreateNewPasswordComponents';
import { useIsSmallScreen } from '../../../hooks';

export const CreateNewPassword = () => {
  const isSmallScreen = useIsSmallScreen();

  return (
    <AuthWrapper>
      <CreateNewPasswordHeader />
      <CreateNewPasswordForm />
      <CreateNewPasswordFooter />
      {!isSmallScreen && <AuthFooterLanguage moveToTop />}
    </AuthWrapper>
  );
};
